import { IFeedbackSite } from '@app/interfaces/feedback-site.interface';

export enum NewFeedbackSiteField {
  NAME = 'name',
  URL = 'url',
  IMAGE_URL = 'imageUrl',
  INDEX = 'index',
  IS_DOCTOR_FEEDBACK = 'isDoctorFeedback',
}

export const NEW_FEEDBACK_SITE: Pick<IFeedbackSite, NewFeedbackSiteField> &
  Partial<Pick<IFeedbackSite, 'id'>> = {
  [NewFeedbackSiteField.NAME]: '',
  [NewFeedbackSiteField.URL]: '',
  [NewFeedbackSiteField.IMAGE_URL]: '',
  [NewFeedbackSiteField.INDEX]: '',
  [NewFeedbackSiteField.IS_DOCTOR_FEEDBACK]: false,
};

export const NewFeedbackSiteFormConfig = [
  { label: 'Название', field: NewFeedbackSiteField.NAME, required: true },
  { label: 'Ссылка', field: NewFeedbackSiteField.URL, required: true },
  { label: 'Ссылка на изображение', field: NewFeedbackSiteField.IMAGE_URL, required: true },
  { label: 'Индекс', field: NewFeedbackSiteField.INDEX, required: true },
];
